import React from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';


import _isEqual from 'lodash/isEqual';
import {getUserInfo, resetUser} from '../../vendors/actions/user'
import FindLawyerSection from "../../elements/findLawyerSection";
import {getCaseTypes, getStates} from "../../vendors/actions/static";
import {setSingleCase} from "../../vendors/actions/case";


interface OwnProps {
    getUserInfo?: any
    getStates?: any,
    getCaseTypes?: any,
    resetUser?: any,
    Case?: any,
    setSingleCase?: any,
}

interface ConnectStateProps {
    User: {
        first_name: string;
        last_name: string;
        avatar: string,
        email: string
    },
    Case: any,
    Error: {
        User: {
            code: number,
            data: {
                error_id: string | number,
                message: string
            }
        }
    }
}

interface ConnectDispatchProps {
    getUserInfo?: () => void;
    getStates?: () => void;
    getCaseTypes?: () => void;
    resetUser?: () => void;
    setSingleCase?: (data: any) => void;
}

interface MainState {
    userIsLoggedIn: boolean,
    user: null | {
        firs_name: string,
        last_name: string,
        email: string
    }
}

type HeaderProps = OwnProps & ConnectStateProps & ConnectDispatchProps;

class CreateCase extends React.Component<HeaderProps, MainState> {
    state = {
        userIsLoggedIn: false,
        user: null
    };

    componentDidMount() {
        this.props.setSingleCase({});
        this.props.getUserInfo();
        this.props.getStates();
        this.props.getCaseTypes();
    }

    static getDerivedStateFromProps(props: any, state: any) {
        const {User, Error, Case, history} = props;
        if (Object.keys(Case).length > 0) {
            if (Error.User) {
                props.resetUser();
            }

            if (!Object.keys(User).length) {
                localStorage.setItem('token', Case.consumer.token);
            }
            if (Case.created) {
                history.push(`/case/${Case.caseData.case_uid}`);
                return null;
            }
            return null;
        }
        if (!_isEqual(state, User)) {
            return {
                userIsLoggedIn: !Error.User,
                user: User
            };
        }
        return null;
    }

    render() {
        return (
            <FindLawyerSection ignoreUserForm={true}/>
        );
    }
}

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {User, Error, Case} = state;
    return {
        User,
        Error,
        Case
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        getUserInfo: () => dispatch(getUserInfo()),
        getStates: () => dispatch(getStates()),
        getCaseTypes: () => dispatch(getCaseTypes()),
        resetUser: () => dispatch(resetUser()),
        setSingleCase: (data: any) => dispatch(setSingleCase(data)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateCase);



